<template>
  <div class="base-feature-track">
    <div class="base-feature-track__wrap">
      <div class="base-feature-track__wrap__form">
        <InputMultitags 
          id="stt_numbers"
          :v-model="sttNumbers"
          :value="sttNumbers"
          :max-item="maxItem"
          name="stt_numbers"
          placeholder="Masukan nomor resi atau STT"
          label="Nomor resi atau STT"
          :desc="`Lacak maks. ${maxItem} STT. pisahkan dengan koma/spasi atau langsung salin, tempel dan tekan enter.`"
          @update:modelValue="onUpdateSttNumbers"
        />
      </div>
      <div class="base-feature-track__wrap__btn">
        <Button
          id="btn_lacak_pengiriman_new"
          text="Lacak sekarang"
          type-class="indigo-dark"
          :round="true"
          :disabled="checkDisabled"
          @click="track"
        />
      </div>
    </div>
    <ModalRecaptcha
      id="tracking-captcha"
      v-model="isModalRecaptcha"
      @response="onCaptchaResponse"
      @expired="onCaptchaExpired"
      @error="onCaptchaError"
      @close="() => { isModalRecaptcha = false }"
    />
  </div>
</template>

<script>
import mixinMobile from '@/misc/mixinMobile';
import Button from "@/components/new-button/Button.vue";
import InputMultitags from "./InputMutlitags.vue";
import ModalRecaptcha from '@/components/new-modal/ModalRecaptcha.vue';
import mixinRecaptcha from '@/components/new-modal/mixinRecaptcha.js';

export default {
  name: "FeatureSectionTrackHome",
  components: {
    InputMultitags,
    Button,
    ModalRecaptcha,
  },
  mixins: [mixinMobile, mixinRecaptcha],
  data() {
    return {
      sttNumbers: [],
      isModalRecaptcha: false,
      maxItem: 5,
    }
  },
  computed: {
    checkDisabled() {
      return this.sttNumbers.length < 1;
    }
  },
  mounted() {
    this.setCaptchaTrackExistLs();
  },
  methods: {
    onUpdateSttNumbers(val) {
      this.sttNumbers = val
    },
    onCaptchaResponse(res) {
      this.captchaResponse = res
      localStorage.setItem('track_captcha_is_exist', false)
      this.isCaptchaTrackExist = false
      this.track()
    },
    track() {
      this.setIsCaptchaTrackExist()
      if (!this.captchaResponse && this.isCaptchaTrackExist && this.sttNumbers.length > 0) {
        this.isModalRecaptcha = true
      } 
      else {
        let goToLink = "/track/stt?q="
        if (this.sttNumbers.length > 0) {
          goToLink += this.sttNumbers
          this.$router.push(goToLink)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.base-feature-track {
  &__wrap {
    display: flex;
    padding: 30px 40px;

    @include for-size(mobile) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(mobile-landscape) {
      flex-direction: column;
      padding: 16px;
    }
    
    @media (min-width: 916px) and (max-width: 1023px) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-portrait) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-landscape-new) {
      flex-direction: column;
      padding: 16px;
    }

    @media (min-width: 690px) and (max-width: 690px) {
      flex-direction: column;
      padding: 16px;
    }
    

    &__form {
      width: 82.5%;

      @include for-size(mobile) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(mobile-landscape) {
        width: auto;
        margin-bottom: 20px;
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(tablet-portrait) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(tablet-landscape-new) {
        width: auto;
        margin-bottom: 20px;
      }

      @media (min-width: 690px) and (max-width: 690px) {
        width: auto;
        margin-bottom: 20px;
      }
    }

    &__btn {
      width: 17.5%;
      margin: auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      ::v-deep .disabled {
        border-radius: 250px;
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        border: unset;
      }

      > div {
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
      }

      @include for-size(mobile) {
        width: 100%;
        
        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(mobile-landscape) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-portrait) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-landscape-new) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 690px) and (max-width: 690px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
